module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAABHklEQVRIib3VMU4CURSF4bE1IoUGLd2HvTERbDRYGHvcgp0rUMDeTaAtK3AHJpYaCA0JFEbzWTAk+gLDewqeZoo59783M++dm2UFQhmnaKODbv5s4QSbRfXzoDtoYqhYQ9ygEgs+Rn8BNFQftUXgy0RoqMY8cO2P4KmqIXgbgwVFb3jGxwLfAFvf4a2Iic5zby/C25yCSxhHFFzk/pifPUIpw1mEORUO9Qx3K4K3MzysCN7JTK50Cvw10t9Nmfwqh+/iPsLfSfnm8Ii9vMk+ngq87ZTTMtUY11jHGhp4n+Grp5zzUC84xAE+g3cjbKTc0HmaNVgzNVti9TNb8gbVJcGP/jfPg1xP3UQ9YY4XNKjg1rJ3aNCkbLLlf7X9vwDeM3lNNvryMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smokeIcon1.png
// module id = viP8
// module chunks = 208